import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from "@opentelemetry/semantic-conventions";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web"
import { ZoneContextManager } from "@opentelemetry/context-zone"

/**
 * Nuxt plugin that starts Open telemetry service for the browser
 */
export default defineNuxtPlugin({
  async setup() {
    const config = useRuntimeConfig().public.instrumentation;
    const { otelServiceName, otelServiceVersion } = config as any;

    const provider = new WebTracerProvider({
      resource: resourceFromAttributes({
        [ATTR_SERVICE_NAME]: otelServiceName,
        [ATTR_SERVICE_VERSION]: otelServiceVersion
      }),
      // todo: add exporter to backend. e.g., Sentry
    });

    provider.register({
      contextManager: new ZoneContextManager(),
    });

    registerInstrumentations({
      instrumentations: [
        getWebAutoInstrumentations(),
      ],
    });
  }
})
